module.exports = __webpack_public_path__ + "static/media/emina.3d0ef725.jpg";